import {
  Button,
  Icon,
  Popover,
  PopoverArrow,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  PopoverBody,
  Portal,
  Flex,
  useMediaQuery,
} from '@chakra-ui/react'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import { IoIosMenu } from 'react-icons/io'
import { Link } from 'react-router-dom'

export function MenuItem({ menuItem }) {
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')
  return (
    <>
      {/* create menu popover */}
      <Popover placement="bottom" isLazy>
        {({ isOpen, onOpen, onClose }) => (
          <>
            <PopoverTrigger>
              <Button
                rightIcon={isOpen ? <IoIosArrowUp color="#37F091" /> : <IoIosArrowDown color="#37F091" />}
                variant="ghost"
                colorScheme="blue"
                size="sm"
                _hover={{ color: '#37F091' }}
                _focus={{ boxShadow: 'none' }}
                padding="0"
                color="white"
                {...(isLargerThan1366 && { fontSize: '13px' })}
              >
                {menuItem.menupai}
              </Button>
            </PopoverTrigger>
            <Portal>
              <PopoverContent onMouseLeave={onClose} onMouseEnter={onOpen} bgColor="#313e44" minW="352px" maxH="700px" overflowY="auto">
                <PopoverArrow />
                <PopoverHeader fontWeight="semibold" color="white" textAlign={'start'}>
                  {menuItem.menupai}
                </PopoverHeader>
                <PopoverCloseButton marginTop="1px" />
                <PopoverBody>
                  <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                    {menuItem.menufilho.map((filho, idx) => {
                      return (
                        <Button
                          key={idx}
                          as={Link}
                          justifyContent="flex-start"
                          padding="0"
                          w="100%"
                          variant="ghost"
                          colorScheme="blue"
                          size="sm"
                          _hover={{ color: 'blue.500' }}
                          _focus={{ boxShadow: 'none' }}
                          leftIcon={<Icon as={IoIosMenu} />}
                          to={filho.menulink}
                          cursor="pointer"
                          color="gray.100"
                        >
                          {filho.menufilho}
                        </Button>
                      )
                    })}
                  </Flex>
                </PopoverBody>
              </PopoverContent>
            </Portal>
          </>
        )}
      </Popover>
    </>
  )
}
